import { createSlice } from "@reduxjs/toolkit";
import { toApplyJob, toGetJobs } from "../actions/job.actions";

const initialState = {
  jobs: {
    list: [],
    status: "",
  } as any,
  jobApply: {
    loading: false,
  } as any,
  loading: false,
  error: null as unknown | null,
};
export const jobsSlice = createSlice({
  name: "jobs",
  initialState: initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(toGetJobs.pending, (state) => {
      state.jobs = { list: [], status: "idle" };
    });
    builder.addCase(toGetJobs.fulfilled, (state, action) => {
      state.jobs = { list: action.payload.data, status: "succedded" };
    });
    builder.addCase(toGetJobs.rejected, (state, action) => {
      state.jobs = { list: [], status: "rejected" };
      state.error = action.payload;
    });

    builder.addCase(toApplyJob.pending, (state) => {
      state.jobApply.loading = true;
    });
    builder.addCase(toApplyJob.fulfilled, (state, action) => {
      state.jobApply = action.payload;
      state.jobApply.loading = false;
    });
    builder.addCase(toApplyJob.rejected, (state, action) => {
      state.jobApply = {};
      state.jobApply.loading = false;
      state.error = action.payload;
    });
  },
});

export default jobsSlice.reducer;
